import Button from 'components/Button';
import Icon from 'components/Icon/Icon';
import { LimitationInputs } from 'components/Limitation/LimitationManager/styles';
import notify from 'components/Notify';
import { notifyError } from 'components/Notify/Notify';
import Select, { IOption } from 'components/Select/Select';
import { SyntheticEvent, useState } from 'react';
import { migrateLimitations } from 'store/limitations/limitationsSlice';
import { appDispatch } from 'store/store';
import i18n from '../../../i18n';

type OwnProps = {
  companyId?: number;
  companyRolesOptions?: IOption[];
  companyMembersOptions?: IOption[];
};

function MigrateUserPermissionsToRole(props: OwnProps) {
  const { companyId, companyRolesOptions, companyMembersOptions } = props;
  const [selectedUser, setSelectedUser] = useState<IOption>();
  const [selectedRole, setSelectedRole] = useState<IOption>();
  const [migrateList, setMigrateList] = useState<
    Array<{
      userId: number;
      userName: string;
      roleId: number;
      roleName: string;
    }>
  >([]);

  function addToMigrateList() {
    if (selectedUser && selectedRole) {
      const temp = {
        userId: selectedUser.value as number,
        userName: selectedUser.label,
        roleId: selectedRole.value as number,
        roleName: selectedRole.label,
      };

      const newList = [...migrateList, temp];

      setMigrateList(newList);
    }
  }

  function removeMigrateFromList(userId: number, roleId: number) {
    const tempList = migrateList.filter((itm) => {
      return itm.userId !== userId || itm.roleId !== roleId;
    });

    setMigrateList(tempList);
  }

  async function migrateRole(e: SyntheticEvent) {
    e.preventDefault();
    e.stopPropagation();

    appDispatch(
      migrateLimitations({ migrateList, companyId: Number(companyId) })
    )
      .then(() => {
        setMigrateList([]);
        setSelectedRole(undefined);
        setSelectedUser(undefined);
        notify(i18n.t('saved', { ns: 'documentManager' }));
      })
      .catch((e: any) => {
        notifyError(e);
      });
  }

  return (
    <form onSubmit={migrateRole} className={'my-3'}>
      <div className="mb-4">
        <Icon type={'info'} className="mx-3" />
        <span>
          {i18n.t('roleMigrationHint', { ns: 'documentManager' }) as string}
        </span>
      </div>
      <LimitationInputs>
        <span className="flex pt-4 mx-2 h-24">
          {i18n.t('userPermission', { ns: 'documentManager' }) as string}
        </span>{' '}
        {companyMembersOptions && (
          <Select
            options={companyMembersOptions}
            placeholder={i18n.t('selectAUser', { ns: 'documentManager' })}
            values={selectedUser ? [selectedUser] : []}
            showValues={false}
            multiChoice={false}
            onChangeValues={(val) => setSelectedUser(val[0])}
          />
        )}
        <span className="flex pt-4 mx-2 h-24">
          {i18n.t('forRole', { ns: 'documentManager' }) as string}
        </span>{' '}
        {companyRolesOptions && (
          <Select
            options={companyRolesOptions}
            placeholder={
              i18n.t('selectACompanyRole', { ns: 'documentManager' }) as string
            }
            values={selectedRole ? [selectedRole] : []}
            showValues={false}
            multiChoice={false}
            onChangeValues={(val) => setSelectedRole(val[0])}
          />
        )}
        <span className="flex pt-4 mx-2 h-24">
          {i18n.t('beenCopied', { ns: 'documentManager' }) as string}.
        </span>{' '}
      </LimitationInputs>
      {migrateList.length !== 0 && (
        <ul>
          {migrateList.map((itm, idx) => {
            return (
              <li key={idx} className="flex items-center my-2">
                <span>{itm.userName}</span>
                <span className="mx-2">{'->'}</span>
                <span>{itm.roleName}</span>
                <Icon
                  className="mx-2 cursor-pointer"
                  onClick={() => removeMigrateFromList(itm.userId, itm.roleId)}
                  type="minus-circle"
                  color="red"
                />
              </li>
            );
          })}
        </ul>
      )}
      <div className="mx-4 flex items-center justify-end">
        <div className="flex items-center gap-3">
          <Button
            type="button"
            color="green-outline"
            disabled={!selectedUser || !selectedRole}
            onClick={addToMigrateList}
          >
            {
              i18n.t('addMigrateLimitationsToList', {
                ns: 'documentManager',
              }) as string
            }
          </Button>
          <Button
            type="submit"
            color="green"
            disabled={migrateList.length === 0}
          >
            {i18n.t('migrateLimitations', { ns: 'documentManager' }) as string}
          </Button>
        </div>
      </div>
    </form>
  );
}

export default MigrateUserPermissionsToRole;
